const name = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
export default { name };
